import React from 'react';
import {CardBody} from 'reactstrap';
import SiteKeyBlock from './SiteKeyBlock';
import ApiRequestsGuide from './ApiRequestsGuide';

const ApiRequests = ({type, tabProps: {api_key}}) => (
  <CardBody className='api-requests'>
    <SiteKeyBlock type={type} api_key={api_key}/>
    {api_key && <ApiRequestsGuide api_key={api_key}/>}
  </CardBody>
);

export default ApiRequests;